<mat-form-field appearance="outline" class="text-filter">
  <input
    matInput
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (change)="onFilterChange()"
  />
</mat-form-field>
